module.exports = __webpack_public_path__ + "img/Semaforo3.bf07eb0d.svg";